import './PeriscopeList.scss';
import classNames from 'classnames';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { NoData } from '@ui/NoData';
import { When } from 'react-if';
import React, { forwardRef } from 'react';
export const PeriscopeList = forwardRef(({ list, loading, results, striped, title }, ref) => {
    const classes = classNames('periscope-paginated-list', { 'periscope-paginated-list-striped': striped });
    return (React.createElement(React.Fragment, null,
        title && React.createElement("div", { className: 'periscope-list-title' }, title),
        React.createElement("div", { className: classes, ref: ref },
            React.createElement(LoadingSpinner, { spinning: loading },
                React.createElement(When, { condition: !loading && results.length === 0 },
                    React.createElement(NoData, null)),
                list(results)))));
});
